module.exports = __webpack_public_path__ + "static/media/bok choy.6eb2fafe.jpg";